<app-header [user]="user()" />

<app-brand-top
  [color]="color"
  [backgroundColor]="backgroundColor"
  [brandImage]="brandImage"
  [brandTitle]="brandTitle"
  [brandDescription]="brandDescription"
  [brandLogo]="brandLogo"
  [bannerClassName]="bannerClassName"
  [brandLogoMobile]="brandLogoMobile"
/>
<!-- <app-brand-description [title]="title" [description]="description" /> -->
@if (!reloadTrainignsData()) {
  <app-trainings-list #trainingsList [isBrandFilterVisible]="false" [trainingBrand]="brand" />
}
<app-brand-dedicated-trainings />
<app-newsletter-section />
